import { render, staticRenderFns } from "./LandingPagePrimaryQuoteSection.vue?vue&type=template&id=5a862b76&scoped=true"
import script from "./LandingPagePrimaryQuoteSection.vue?vue&type=script&lang=js"
export * from "./LandingPagePrimaryQuoteSection.vue?vue&type=script&lang=js"
import style0 from "./LandingPagePrimaryQuoteSection.vue?vue&type=style&index=0&id=5a862b76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a862b76",
  null
  
)

export default component.exports